<mat-card *ngIf="!chooseWarehouse; else warehouses">
  <mat-card-header>
    <h2>
      {{ 'FILTER.TITLE_FILTER_DIALOG' | translate }}
    </h2>
    <button mat-button (click)="reset()">
      {{ 'FILTER.TEXT_RESET' | translate }}
    </button>
  </mat-card-header>
  <mat-card-content>

    <!-- Warehouse Select -->
    <section>
      <h3>{{ 'FILTER.TITLE_WAREHOUSES' | translate }}</h3>
      <section>
        <button mat-flat-button class="plain" (click)="this.chooseWarehouse = true">
          {{ selectedWarehouseName  || 'FILTER.ALL_WAREHOUSES' | translate }}
        </button>
      </section>
    </section>

    <section>
      <h3>{{ 'FILTER.TITLE_SHOW_ONLY' | translate }}</h3>
      <!-- Filter Landed -->
      <section>
        <!-- <figure>
          <button mat-icon-button (click)="showLanded = !showLanded">
            <mat-icon [svgIcon]="showLanded ? 'landed-selected' : 'landed'"></mat-icon>
          </button>
          <figcaption>{{ 'FILTER.TEXT_SHOW_LANDED' | translate }}</figcaption>
        </figure> -->
        <!-- Filter Not Landed -->
        <figure>
          <button mat-icon-button (click)="showNotLanded = !showNotLanded">
            <mat-icon [svgIcon]="showNotLanded ? 'not-landed-selected' : 'not-landed'"></mat-icon>
          </button>
          <figcaption>{{ 'FILTER.TEXT_SHOW_NOT_LANDED' | translate }}</figcaption>
        </figure>
        <!-- Filter Single length -->
        <figure>
          <button mat-icon-button (click)="showSingleLength = !showSingleLength">
            <mat-icon [svgIcon]="showSingleLength ? 'single-length-selected' : 'single-length'"></mat-icon>
          </button>
          <figcaption>{{ 'FILTER.TEXT_SHOW_SINGLE_LENGTH' | translate }}</figcaption>
        </figure>
      </section>
    </section>

    <!-- Certification Select -->
    <section>
      <h3>{{ 'FILTER.TITLE_CERTIFICATES' | translate }}</h3>
      <section>
        <mat-radio-group [(ngModel)]="certificate" class="narrow">
          <mat-radio-button class="plain" [value]="" (checked)="certificate = undefined">
            {{ 'FILTER.OPTION_ALL' | translate }}
          </mat-radio-button>
          <mat-radio-button class="plain" [value]="FILTER_NO_CERTIFICATE"
            (checked)="certificate = FILTER_NO_CERTIFICATE">
            {{ 'FILTER.OPTION_NONE' | translate }}
          </mat-radio-button>
          <mat-radio-button class="plain" *ngFor="let cert of codesApiService.certificates$ | async"
            [value]="cert.value" (click)="certificate === cert.value ? certificate = null : ''">
            {{ 'CERTIFICATE.' + cert.value | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </section>
    </section>

    <section>
      <!-- Length Slider -->
      <h3> {{ 'FILTER.TITLE_LENGTH' | translate }}</h3>
      <section>
        <ngx-slider class="length-slider" [(value)]="minLength" [(highValue)]="maxLength"
          [options]="lengthSliderOptions" [manualRefresh]="refreshLengthSlider"></ngx-slider>
        <!-- <mat-slider min="1" max="5" step="0.5" value="1.5"></mat-slider> -->
      </section>
    </section>

  </mat-card-content>

  <mat-card-actions>
    <button mat-button class="confirm" (click)="close()">{{ 'FILTER.TEXT_OK' | translate }}</button>
  </mat-card-actions>
</mat-card>

<ng-template #warehouses>
  <mat-card>
    <button mat-button class="back" (click)="chooseWarehouse = false">
      {{ 'FILTER.TEXT_BACK' | translate }}
    </button>
    <mat-card-header>
      <h2>
        {{ 'FILTER.TITLE_WAREHOUSES' | translate }}
      </h2>
    </mat-card-header>
    <mat-card-content>

      <!-- Warehouse Select -->
      <mat-list>
        <mat-list-item [ngClass]="{'selectedWarehouse' : !selectedWarehouse}" (click)="setWarehouse('','')">
          {{ 'FILTER.ALL_WAREHOUSES' | translate }}
        </mat-list-item>
        <mat-list-item *ngFor="let wh of terminalsApiService.warehouses$ | async"
          [ngClass]="{'selectedWarehouse' : selectedWarehouse === wh.code}" (click)="setWarehouse(wh.name,wh.code)">
          {{ wh.name }} ({{ wh.code }})
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
</ng-template>
